var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoHistory(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 72,
    viewBox: "0 0 78 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Exp-3.-G"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.04626 1.46372C5.04626 1.07437 5.19995 0.702585 5.47513 0.428869C5.74884 0.153691 6.12209 0 6.50997 0H39.5226L56.2764 18.5775V41.9282C56.2764 41.9282 56.329 61.2156 50.8504 70.4238C50.584 70.8468 50.1185 71.103 49.6179 71.103C44.0163 71.1074 10.7591 71.1074 1.46161 71.1074C0.949313 71.1074 0.473605 70.8381 0.208672 70.3975C-0.0562605 69.9569 -0.0694341 69.4095 0.172079 68.9572C4.71399 59.0946 5.04626 41.9282 5.04626 41.9282V1.46372Z",
    fill: "url(#paint0_linear_9595_45862)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.2764 41.9282C56.2764 41.9282 56.329 61.2156 50.8504 70.4239C50.584 70.8469 50.1185 71.103 49.6179 71.103C44.0163 71.1074 10.7591 71.1074 1.46161 71.1074C0.949313 71.1074 0.473605 70.8381 0.208672 70.3975C-0.0562605 69.9569 -0.0694341 69.4095 0.172079 68.9572L0.229164 68.8299C18.2534 69.6774 44.4276 66.5201 47.8746 65.1706C51.5573 63.7303 56.2032 49.8952 56.2749 42.1112L56.2764 41.9282Z",
    fill: "url(#paint1_linear_9595_45862)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.2767 18.5775C51.8328 16.8225 47.1284 16.7727 42.2996 17.5192C41.8517 17.5895 41.3965 17.4475 41.0672 17.1343C40.7378 16.821 40.5739 16.3731 40.6222 15.9223C41.1521 10.5153 40.6178 5.22547 39.5229 0C46.6044 5.25621 52.1958 11.4448 56.2767 18.5775Z",
    fill: "url(#paint2_linear_9595_45862)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3622 29.7458H31.5456C32.3536 29.7458 33.0093 29.09 33.0093 28.2821C33.0093 27.4741 32.3536 26.8184 31.5456 26.8184H12.3622C11.5542 26.8184 10.8984 27.4741 10.8984 28.2821C10.8984 29.09 11.5542 29.7458 12.3622 29.7458Z",
    fill: "url(#paint3_linear_9595_45862)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3622 37.0642H25.9938C26.8017 37.0642 27.4575 36.4084 27.4575 35.6004C27.4575 34.7925 26.8017 34.1367 25.9938 34.1367H12.3622C11.5542 34.1367 10.8984 34.7925 10.8984 35.6004C10.8984 36.4084 11.5542 37.0642 12.3622 37.0642Z",
    fill: "url(#paint4_linear_9595_45862)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3622 44.383H25.9938C26.8017 44.383 27.4575 43.7273 27.4575 42.9193C27.4575 42.1113 26.8017 41.4556 25.9938 41.4556H12.3622C11.5542 41.4556 10.8984 42.1113 10.8984 42.9193C10.8984 43.7273 11.5542 44.383 12.3622 44.383Z",
    fill: "url(#paint5_linear_9595_45862)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3622 51.7014H25.9938C26.8017 51.7014 27.4575 51.0456 27.4575 50.2376C27.4575 49.4297 26.8017 48.7739 25.9938 48.7739H12.3622C11.5542 48.7739 10.8984 49.4297 10.8984 50.2376C10.8984 51.0456 11.5542 51.7014 12.3622 51.7014Z",
    fill: "url(#paint6_linear_9595_45862)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M55.9807 66.5214C68.1065 66.5214 77.9364 56.6915 77.9364 44.5656C77.9364 32.4398 68.1065 22.6099 55.9807 22.6099C43.8548 22.6099 34.0249 32.4398 34.0249 44.5656C34.0249 56.6915 43.8548 66.5214 55.9807 66.5214Z",
    fill: "url(#paint7_linear_9595_45862)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.1345 41.1977C46.0168 34.1748 53.2373 29.9563 60.2617 31.8387C67.2846 33.721 71.4577 40.9503 69.5768 47.9732C67.6945 54.9961 60.4652 59.1692 53.4423 57.2883C52.6621 57.079 51.8585 57.543 51.6492 58.3232C51.4399 59.1033 51.9039 59.9069 52.6841 60.1162C61.2673 62.4157 70.1038 57.3147 72.4033 48.73C74.7042 40.1467 69.6017 31.3117 61.0185 29.0108C52.4352 26.7113 43.6075 31.8577 41.308 40.4409C41.0987 41.2211 41.5627 42.0247 42.3429 42.234C43.1231 42.4418 43.9266 41.9793 44.1345 41.1977Z",
    fill: "url(#paint8_linear_9595_45862)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.4248 35.7893L41.272 41.3456C41.5266 42.1126 42.3551 42.5268 43.1221 42.2721L48.6784 40.4249C49.4439 40.1702 49.8596 39.3403 49.6049 38.5733C49.3502 37.8078 48.5203 37.3921 47.7548 37.6468L43.5876 39.0329L42.2014 34.8657C41.9467 34.0987 41.1183 33.683 40.3513 33.9377C39.5843 34.1939 39.1686 35.0223 39.4248 35.7893Z",
    fill: "url(#paint9_linear_9595_45862)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.9815 37.2474V46.8201L51.3694 50.7721C50.7561 51.2976 50.6843 52.2227 51.2113 52.836C51.7368 53.4493 52.6618 53.521 53.2751 52.9955L58.3981 48.6044C58.7216 48.3263 58.909 47.9194 58.909 47.4934V37.2474C58.909 36.4394 58.2532 35.7837 57.4453 35.7837C56.6373 35.7837 55.9815 36.4394 55.9815 37.2474Z",
    fill: "url(#paint10_linear_9595_45862)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9595_45862",
    x1: 6.20113,
    y1: -0.144907,
    x2: 46.2997,
    y2: 65.4252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CADCF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9595_45862",
    x1: -0.000639362,
    y1: 56.5186,
    x2: 56.2763,
    y2: 56.5186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9595_45862",
    x1: 39.5229,
    y1: 9.28875,
    x2: 56.2767,
    y2: 9.28875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#559AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E69EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_9595_45862",
    x1: 10.8984,
    y1: 28.2821,
    x2: 33.0093,
    y2: 28.2821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#559AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E69EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_9595_45862",
    x1: 10.8984,
    y1: 35.6004,
    x2: 33.0093,
    y2: 35.6004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#559AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E69EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_9595_45862",
    x1: 10.8984,
    y1: 42.9193,
    x2: 33.0093,
    y2: 42.9193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#559AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E69EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_9595_45862",
    x1: 10.8984,
    y1: 50.2376,
    x2: 33.0093,
    y2: 50.2376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#559AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E69EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_9595_45862",
    x1: 39.5212,
    y1: 28.4633,
    x2: 70.9003,
    y2: 60.668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8FBFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CADCF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_9595_45862",
    x1: 42.0121,
    y1: 34.1367,
    x2: 68.9972,
    y2: 55.3372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#559AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E69EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_9595_45862",
    x1: 42.0111,
    y1: 34.1368,
    x2: 68.9962,
    y2: 55.3373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#559AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E69EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_9595_45862",
    x1: 52.3515,
    y1: 38.1051,
    x2: 57.1071,
    y2: 50.2379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#559AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E69EF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoHistory);
export default __webpack_public_path__ + "static/media/noHistory.4a9d9a37da855c4cb52822baeba783e7.svg";
export { ForwardRef as ReactComponent };